import { render } from "./WeekPicker.vue?vue&type=template&id=1624e804&scoped=true"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"

import "./WeekPicker.vue?vue&type=style&index=0&id=1624e804&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1624e804"]])

export default __exports__